import React from 'react';
import styles from './contact.module.css';

export default function Contact() {
  return (
    <section id="contact" className={styles.contact}>
      <div className={styles.container}>
        <h2 className="section-header center">Contact</h2>
        <h3 className={styles.contactSubtitle}>I&rsquo;d love to hear from you!</h3>
        <div className={styles.contactContent}>
          <div className={styles.contactDetails}>
            <div className={styles.contactColumn}>
              <div className={styles.contactBlock}>
                <h4>Media &amp; Press Inquiries</h4>
                <p>For press, speaking events, or media inquiries, please contact <strong>Ivy Cheng</strong></p>
                <div className={styles.contactEmail}>
                  <a href="mailto:icheng@penguinrandomhouse.com">icheng@penguinrandomhouse.com</a>
                </div>
              </div>
            </div>

            <div className={styles.contactColumn}>
              <div className={styles.contactBlock}>
                <h4>Contact Meghan</h4>
                <p>To reach Meghan for other inquiries:</p>
                <div className={styles.contactEmail}>
                  <a href="mailto:hello@meghanrabbitt.com">hello@meghanrabbitt.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}